import React, { useEffect, useState } from "react";
import { AsyncCallArgs, CardSpg, ErrorAlert, SuccessAlert, useAsyncCall } from "@duosoftbg/nacid-components";
import { userAccountActivation } from "../../../../../axios/api/services";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PageWrapper from "../../../../components/common/layout/PageWrapper";
import { CardContent } from "@mui/material";
import { TemporaryKeyStatusType } from "../../../../../constants/temporaryKeyStatusType";

const renderAccountActivationResult = (activationResult) => {
  if (activationResult.status) {
    switch (activationResult.status) {
      case TemporaryKeyStatusType.KEY_NOT_FOUND:
        return <ErrorAlert message={"m.account.activation.key.invalid"} />;
      case TemporaryKeyStatusType.USER_NOT_FOUND:
        return <ErrorAlert message={"m.account.activation.user.invalid"} />;
      case TemporaryKeyStatusType.USED_KEY:
        return (
          <ErrorAlert message={"m.account.activation.already.activated"} dynamicValuesObject={activationResult.user} />
        );
      case TemporaryKeyStatusType.EXPIRED_KEY:
        return <ErrorAlert message={"m.account.activation.key.expired"} />;
      case TemporaryKeyStatusType.EXCEPTION:
        return <ErrorAlert message={"m.account.activation.key.error"} />;
      case TemporaryKeyStatusType.SUCCESS:
        return (
          <SuccessAlert
            message={"m.account.activation.success"}
            dynamicValuesObject={{ user: activationResult.user }}
          />
        );
      default:
        return null;
    }
  }
};

const AccountActivation = () => {
  const { t } = useTranslation();
  const { asyncCall } = useAsyncCall();
  const [searchParams] = useSearchParams();
  const [activationResult, setActivationResult] = useState({ status: null, user: null });

  useEffect(() => {
    const asyncCallArgs: AsyncCallArgs = {
      promise: userAccountActivation(searchParams.get("key")),
      onSuccess: (response) => {
        setActivationResult(response);
      },
      onError: () => {
        setActivationResult({ status: TemporaryKeyStatusType.EXCEPTION, user: null });
      },
    };
    asyncCall(asyncCallArgs);

    // eslint-disable-next-line
    }, []);

  return (
    <PageWrapper title={t("t.page.account.activation")}>
      <CardSpg my={4} style={{ overflow: "visible" }}>
        <CardContent style={{ padding: 24, position: "relative" }}>
          {renderAccountActivationResult(activationResult)}
        </CardContent>
      </CardSpg>
    </PageWrapper>
  );
};

export default AccountActivation;
